module.exports = __webpack_public_path__ + "img/thumbnail_AldabraGiantTortoise_m_normal.c53adebb.png";